// action types
export const ENABLE_PAYMENT_SUMMARY = 'rp/paymentSummary/ENABLE_PAYMENT_SUMMARY'
export const DISABLE_PAYMENT_SUMMARY =
  'rp/paymentSummary/DISABLE_PAYMENT_SUMMARY'

// action creators
export const enablePaymentSummary = payload => ({
  type: ENABLE_PAYMENT_SUMMARY,
  payload,
})
export const disablePaymentSummary = payload => ({
  type: DISABLE_PAYMENT_SUMMARY,
  payload,
})

// reducer
export default (state = 0, { type }) => {
  switch (type) {
    case ENABLE_PAYMENT_SUMMARY:
      return 1
    case DISABLE_PAYMENT_SUMMARY:
      return 0
    default:
      return state
  }
}
